import { useCallback } from 'react';
import { useFeatureFlagsContext } from '../ui/FeatureFlagsContext/FeatureFlagsContext';

export enum Features {
  eventPostbacksReview = 'eventPostbacksReview',
  lifetimeSelectTwoYearsExtension = 'lifetimeSelectTwoYearsExtension',
  lifetimeSelectThreeYearsExtension = 'lifetimeSelectThreeYearsExtension',
  dashboards = 'dashboards',
  overview = 'overview',
  navigationV2switcher = 'navigationV2switcher',
  navigationV2 = 'navigationV2',
}

enum AccessEntity {
  user = 'user',
  company = 'company',
  organization = 'organization',
}
type AccessRecord =
  | {
      type: AccessEntity.company;
      postfix: string;
    }
  | { type: AccessEntity.user; email: string }
  | { type: AccessEntity.organization; organizationId: string };

const FEATURE_GROUPS: Record<Features, AccessRecord[]> = {
  [Features.eventPostbacksReview]: [],
  [Features.lifetimeSelectTwoYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: '4a6b0c93-ecda-46ea-bd58-92553abb73ae',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7c2d76c6-b64a-4cc8-87e0-d5c303e77765',
    },
  ],
  [Features.lifetimeSelectThreeYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: 'dd59e7c3-7668-47d9-999c-7909cfabe234',
    },
  ],
  [Features.dashboards]: [
    { type: AccessEntity.company, postfix: 'campaignswell.com' },
    {
      type: AccessEntity.organization,
      organizationId: '932d04c9-f8ca-4b86-acd5-2e6851936c12',
    },
    {
      type: AccessEntity.organization,
      organizationId: '6466a2b3-e65b-4da0-83e6-4d5c5beaf65b',
    },
  ],
  [Features.overview]: [
    { type: AccessEntity.company, postfix: 'campaignswell.com' },
  ],
  [Features.navigationV2switcher]: [
    { type: AccessEntity.company, postfix: 'campaignswell.com' },
    {
      type: AccessEntity.organization,
      organizationId: '932d04c9-f8ca-4b86-acd5-2e6851936c12',
    },
    {
      type: AccessEntity.organization,
      organizationId: '6466a2b3-e65b-4da0-83e6-4d5c5beaf65b',
    },
  ],
  [Features.navigationV2]: [
    {
      type: AccessEntity.organization,
      organizationId: '5f92584e-2ea6-4b99-bc79-c79cc519179b',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7509fd6e-8669-40fe-9556-0a0427ee3c83',
    },
  ],
};

export const useFeatureFlags = () => {
  const { email, organizationId } = useFeatureFlagsContext();
  const isFeatureAvailable = useCallback(
    (feature: Features) => {
      const groups = FEATURE_GROUPS[feature];

      return (
        !!email &&
        groups.some((group) => {
          switch (group.type) {
            case AccessEntity.company:
              return email.endsWith(group.postfix);
            case AccessEntity.user:
              return email === group.email;
            case AccessEntity.organization:
              return organizationId === group.organizationId;
          }

          return false;
        })
      );
    },
    [email, organizationId],
  );

  return {
    isFeatureAvailable,
  };
};
